import Cookies from 'js-cookie';

const isConsentCookie = (candidate) =>
    typeof candidate === 'object' &&
    candidate !== null &&
    'categories' in candidate &&
    candidate.categories !== undefined &&
    Array.isArray(candidate.categories);

export const isCookieEnabled = (cookieCategoryID) => {
    if (!window.config || !window.config.ga_measurement_id) {
        return false;
    }

    const consentCookie = Cookies.get('cookie_consent');

    if (!consentCookie) {
        return false;
    }

    const parsedCookie = JSON.parse(consentCookie);

    if (!isConsentCookie(parsedCookie)) {
        return false;
    }

    const analyticsCookieCategory = parsedCookie.categories.find(
        (cookieCategory) => cookieCategory.id === cookieCategoryID
    );

    if (!analyticsCookieCategory) {
        return false;
    }

    return analyticsCookieCategory.accepted;
};


// WEBPACK FOOTER //
// ./services/cookieChecks.js